if(!customElements.get("dropdown-menu")) {
  customElements.define("dropdown-menu", class DropdownMenu extends HTMLElement {
    constructor() {
      super();

      this.isFooterMenu = this.classList.contains("footer-block--menu");
      this.isFooterMenu ? this.setFooterMenu() : "";
    }

    setFooterMenu() {
      const heading = this.querySelector(".footer-block__heading");
      heading.addEventListener("click", () => { console.log("clicked"); this.classList.toggle("expanded") });
    }
  });
}
